import { Injectable } from '@angular/core';
import { PaymentFoerdersummenDisplayModel, PaymentFoerdersummenDisplayModelFormGroup } from '@/api/model-index';

@Injectable({
    providedIn: 'root'
})
export class PaymentService
{
    public formGroup: PaymentFoerdersummenDisplayModelFormGroup = PaymentFoerdersummenDisplayModelFormGroup.Instance;
    public payments: PaymentFoerdersummenDisplayModel[] = [];
}
